import script from "./StarsIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./StarsIcon.vue?vue&type=script&setup=true&lang=js"

import "./StarsIcon.vue?vue&type=style&index=0&id=aff30254&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aff30254"]])

export default __exports__